import React from 'react';
import PropTypes from 'prop-types';
import { pageShell } from '../styles/pageShell';
import { typeShell } from '../styles/typeShell';

function ProjectDescriptionModal({ isOpen, onClose, project }) {
    if (!isOpen) return null;

    const projectName = project?.name || 'プロジェクト';
    const description = project?.description;
    const thumbnailUrl = project?.thumbnail_image_url || project?.thumbnail_image;

    return (
        <div
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/70 p-0 animate-modal-fade-in bp-lg:px-[10vw] bp-lg:pb-[10vh] bp-lg:pt-[20vh]"
            onClick={onClose}
        >
            <div
                className="max-h-[90vh] w-[98%] max-w-[37.5rem] overflow-y-auto rounded-xl bg-surface shadow-none animate-modal-slide-in bp-lg:w-[95%] bp-lg:max-h-[85vh]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between border-0 border-b border-solid border-border-light px-3 pb-2 pt-3 bp-lg:px-4 bp-lg:pb-3 bp-lg:pt-4">
                    <h3 className={`${pageShell.sectionTitle} m-0`}>
                        {projectName}の説明
                    </h3>
                    <button
                        className={pageShell.closeButton}
                        onClick={onClose}
                        aria-label="閉じる"
                        type="button"
                    >
                        <span className="material-symbols-outlined text-icon-control">close</span>
                    </button>
                </div>
                <div className="p-3 bp-lg:p-4">
                    {thumbnailUrl && (
                        <div className="mb-6 text-center">
                            <img
                                src={thumbnailUrl}
                                alt={`${projectName}のサムネイル`}
                                className="pointer-events-none mx-auto h-auto w-1/2 max-w-full select-none rounded-xl border-2 border-solid border-border-light object-contain shadow-none bp-lg:h-[30vh] bp-lg:w-auto"
                            />
                        </div>
                    )}

                    <div className="leading-relaxed text-text-primary">
                        {description ? (
                            description.split('\n').map((paragraph, index) => (
                                <p key={index} className={`mb-4 last:mb-0 ${typeShell.body}`}>
                                    {paragraph}
                                </p>
                            ))
                        ) : (
                            <>
                                <p className={`mb-4 ${typeShell.body}`}>
                                    このプロジェクトは、地域の歴史的・文化的価値を保存し、次世代に伝えることを目的として作成されました。
                                    地図上に表示されている各マーカーは、重要な場所や建物、歴史的出来事に関連する情報を含んでいます。
                                </p>
                                <p className={`mb-4 ${typeShell.body}`}>
                                    各マーカーをクリックすると、その場所に関する詳細な情報や写真、関連資料を閲覧することができます。
                                    また、左側のフィルター機能を使用して、特定のカテゴリやラベルに基づいてマーカーを絞り込むことができます。
                                </p>
                                <p className={`mb-0 ${typeShell.body}`}>
                                    このデジタルアーカイブは、地域の歴史を学び、理解を深めるための貴重なリソースとして活用していただけます。
                                    何かご質問やご意見がございましたら、お気軽にお問い合わせください。
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

ProjectDescriptionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    project: PropTypes.object
};

export default ProjectDescriptionModal;
